<template>
 <div class="enterpriseIntroduce">
   <div class="left_img">
     <img :src="introduction" alt="">
   </div>
   <div class="right_font">
     <marquee width="100%" height="168px" direction="up" scrollamount="2">
       <span v-html="remark"></span>
     </marquee>
   </div>
 </div>
</template>

<script>
import introduction from './img/introduction.png';
import jsonData from '/public/static/js/json/operateManage.json';
export default {
  name: 'enterpriseIntroduce',
  data() {
    return {
      introduction,
      remark: ''
    }
  },
  mounted() {
    this.remark = jsonData.processIntroduce.remark;
  }
}
</script>

<style scoped lang="scss">
.enterpriseIntroduce {
  display: flex;
  width: 100%;
  .left_img {
    flex: 1;
    height: 180px;
    img {
      height: 100%;
      width: 100%;
      box-sizing: border-box;
    }
  }
  .right_font {
    flex: 1;
    padding-left: 20px;
  }
}
</style>
